import { getStartOfDayTime } from '@/app/_components/widgets/listing/_utils/time';
import { capitalizeWordsInString } from '@/utils/string';

type Props = { firstTimeAvailable: number | null | undefined };

const getDateTitle = (date: number) => {
  const todayMs = getStartOfDayTime(Date.now());

  if (date === todayMs) return 'Oggi';

  const tomorrowMs = getStartOfDayTime(Date.now(), 1);

  if (date === tomorrowMs) return 'Domani';

  const dateObj = new Date(date);

  return capitalizeWordsInString(
    dateObj
      .toLocaleDateString('it', { weekday: 'short', day: 'numeric', month: 'long' })
      // Aggiunta virgola dopo il nome del giorno
      .replace(/(\w+)\s/, '$1, '),
  );
};

export const CardAvailabilityInfo: React.FC<Props> = ({ firstTimeAvailable }) => (
  <div className="flex flex-col gap-2 font-medium">
    <p className="text-sm text-neutral-lighter md:text-base">Prima disponibilità</p>

    <p className={`text-lg ${firstTimeAvailable ? 'text-neutral-darker' : 'text-neutral-inactive'} md:text-xl`}>
      {firstTimeAvailable ? getDateTitle(getStartOfDayTime(firstTimeAvailable)) : 'Non disponibile'}
    </p>
  </div>
);
